import { render, staticRenderFns } from "./descriptionSpecialtyEnrollSteps.vue?vue&type=template&id=aba5e018&scoped=true&"
import script from "./descriptionSpecialtyEnrollSteps.vue?vue&type=script&lang=js&"
export * from "./descriptionSpecialtyEnrollSteps.vue?vue&type=script&lang=js&"
import style0 from "./descriptionSpecialtyEnrollSteps.vue?vue&type=style&index=0&id=aba5e018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba5e018",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
